
class ForgotPasswordController {

    user: any = {};
    sended: boolean = false;
    turnstileToken: string = '';
    turnstileVerified: boolean = false;
    turnstileEnabled: boolean = false;

    static $inject = ['$scope', '$state', 'dialogs', 'Auth', 'TurnstileService'];
    constructor(private $scope, private $state, private dialogs, private Auth, private TurnstileService) {
        TurnstileService.getConfig().then((config) => {
            this.turnstileEnabled = config.enabled && !!config.siteKey;
        }, () => {
            this.turnstileEnabled = false;
        });
    }


    reset() {
        this.$scope.$broadcast('submitted', true);

        if (this.$scope.forgotForm.$valid) {
            if (this.turnstileEnabled && !this.turnstileVerified) {
                this.dialogs.error('Error', 'Please complete the security verification.');
                return;
            }

            if (this.turnstileEnabled) {
                this.user.turnstileToken = this.turnstileToken;
            }

            this.Auth.forgotPassword(this.user)
                .then((data) => {
                    this.sended = true;
                }, (error) => {
                    if (this.turnstileEnabled) {
                        this.turnstileToken = '';
                        this.turnstileVerified = false;
                        this.$scope.$broadcast('turnstile:reset');
                    }
                    this.dialogs.error('Error', error);
                });
        }
    }

    onTurnstileVerified(token: string) {
        this.turnstileToken = token;
        this.turnstileVerified = true;
    }

    onTurnstileError() {
        this.turnstileToken = '';
        this.turnstileVerified = false;
    }

    onTurnstileExpired() {
        this.turnstileToken = '';
        this.turnstileVerified = false;
        this.$scope.$broadcast('turnstile:reset');
    }
}

angular
    .module('app')
    .controller('ForgotPasswordController', ForgotPasswordController);
